<template>
  <div class="results-wrapper min-h-[100vh]">
    <AllResultsComponent />
  </div>
</template>

<script>
import AllResultsComponent from '@/components/common/AllResultsComponent.vue';

export default {
  name: 'AllResultsWrapper',
  components: {
    AllResultsComponent,
  },
};
</script>

<style scoped>
.all-results-wrapper {
  max-width: 90vw;
  margin: auto;
  min-height: calc(100vh - 270px);
}
</style>